import React, { useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Image, Button, Form, Spinner } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";
import config from "../../config";
import debounce from "lodash.debounce";
import { InputGroup, FormControl } from "react-bootstrap";
import axios from "axios";


const Blog = () => {
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [totalblog, setTotalblog] = useState(0);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [offset, setOffset] = useState(0);
  const [error, setError] = useState(null);

  const [blogCategory, setBlogCategory] = useState([]);
  const [blogCategoryId, setBlogCategoryId] = useState("");

  const fetchBlogs = useCallback(
    debounce((requestData) => {
      const apiUrl = `${config.API_BASE_URL}/blog`;
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 1) {
            // Replace blogs with filtered results
            if (requestData.offset === 0) {
              setFilteredBlogs(response.data.latest_blog);
            } else {
              setFilteredBlogs((prevBlogs) => [
                ...prevBlogs,
                ...response.data.latest_blog,
              ]);
            }
            setTotalblog(response.data.total_blog);
          } else {
            setError("Failed to load content");
            console.error("Error:", response.message);
          }
          setLoading(false);
        })
        .catch((error) => {
          setError("Fetch error");
          console.error("Fetch Error:", error);
          setLoading(false);
        });
    }),
    []
  );

  const handleInputSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    // Prepare the request payload with the input value
    const requestData = {
      offset: 0,
      search_val: value,
      category_id: blogCategoryId,
    };
    setFilteredBlogs([]); // Reset blogs for new search
    setOffset(0); // Reset offset
    setLoading(true);
    // setTotalblog();
    fetchBlogs(requestData);
  };

  const handleCategoryChange = (event) => {
    const selectedId = event.target.value; // Get the value of the selected option
    setBlogCategoryId(selectedId); // Update state

    // Prepare the request payload with the input value
    const requestData = {
      offset: 0,
      search_val: searchValue,
      category_id: selectedId,
    };

    setFilteredBlogs([]); // Reset blogs for new search
    setOffset(0); // Reset offset
    setLoading(true);
    // setTotalblog();
    fetchBlogs(requestData);
    console.log("Selected Category ID:", selectedId); // Optional: Log the value for debugging
  };

  const handleViewMore = () => {
    const newOffset = offset + 12;
    setOffset(newOffset);
    const requestData = {
      offset: newOffset,
      search_val: searchValue,
    };
    fetchBlogs(requestData);
  };

  useEffect(() => {
    document.title = "Blog | Agile Seekers";
    document.getElementById("bodywrap").className = "blogmain";
    fetchBlogs({ offset: 0, search_val: 0 }); // Initial fetch

    const Blog_Category_url = `${config.API_BASE_URL}/blog_category`;

    // Make the POST request using axios
    axios
      .post(Blog_Category_url, {})
      .then((response) => {
        if (response.data.status === 1) {
          setBlogCategory(response.data.data);
          console.log(response.data.data)
        } else {
          setError("Failed to load content");
          console.error("Error:", response.data.message);
        }
        setLoading(false); // Hide loading indicator
      })
      .catch((error) => {
        console.error("Axios Error:", error);
      });

  }, [fetchBlogs]);

  return (
    <>
      <Navbar />
      {/* <section className="blog-search">
        <Container>
          <Row>
            <Col md={6}>
              <h3>Agile Seeker Resources</h3>
              <p>
                Explore insights, tips, and articles written by experts in a
                range of professional domains.
              </p>
              <Form>
                <Col className="fr-search">
                  <Row>
                    <Col xs="auto" className="pe-0">
                      <Button>
                        <Image
                          src={`${config.BASE_URL}/assets/images/search.png`}
                          className="img-fluid"
                          alt="search"
                        />
                      </Button>
                    </Col>
                    <Col className="ps-0">
                      <Form.Control
                        type="text"
                        plaintext
                        placeholder="search"

                      />
                    </Col>
                  </Row>
                </Col>
              </Form>
            </Col>
            <Col md={6}>
              <Image
                src={`${config.BASE_URL}/assets/images/blog.jpg`}
                className="img-fluid"
                alt="blog"
              />
            </Col>
          </Row>
        </Container>
      </section> */}

      <div className="container mt-5">
        <div className="resource-banner">
          <div className="row">
            {/* Text Content */}
            <div className="col-lg-12 col-md-10 me-3">
              <h2>AGILE SEEKER RESOURCES</h2>
              <p>
                Explore insights, tips, and articles written by experts in a
                range of <br></br>professional domains.
              </p>

              {/* Search & Dropdown */}
              <InputGroup>
                {/* Search Bar */}
                <div className="serchbar">
                  <FormControl placeholder="Search" className="rounded-start" value={searchValue}
                    onChange={handleInputSearch} />
                </div>

                {/* Category Dropdown */}
                <div className="dropbar">
                  <Form.Select
                    aria-label="Default select example"
                    className="dropdown-toggle"
                    onChange={handleCategoryChange}
                    value={blogCategoryId} // Bind state to value
                  >
                    <option value="" disabled>
                      Select categories
                    </option>
                    {!loading && !error && (
                      blogCategory.length > 0 ? (
                        blogCategory.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        ))
                      ) : (
                        <option disabled>No data available</option>
                      )
                    )}
                  </Form.Select>
                </div>
              </InputGroup>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-bot-sec">
        <Container>
          <Row className="lpbox">
            <Col md={12}>
              <h3>Latest Posts</h3>
            </Col>

            {loading && (
              <Col md={12} className="lpsingle text-center">
                <Spinner animation="border" variant="dark" />
              </Col>
            )}
            {!loading && error && (
              <Col md={3} className="lpsingle">
                {error}
              </Col>
            )}
            {!loading &&
              !error &&
              (filteredBlogs.length > 0 ? (
                filteredBlogs.map((item, index) => (
                  <Col md={3} id={item.id} className="lpsingle" key={index}>
                    <div>
                      <Image src={item.image} className="img-fluid" alt="rr1" title={item.image_title} />
                      <h3>{item.name}</h3>

                      {/* <p>{addQuotestrimToDescription(item.description)}</p> */}
                      <Link
                        to={`/blog/${item.seo_slug}`}
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        View Detail
                      </Link>
                      <div>
                        <p>
                          By <span>{item.author}</span>
                        </p>
                        <p>{item.published}</p>
                      </div>
                    </div>
                  </Col>
                ))
              ) : (
                <Col>
                  <p>No blog posts found.</p>
                </Col>
              ))}
          </Row>
          <Row>
            {filteredBlogs.length < totalblog && (
              <Col md={12} className="lpvm-btn">
                <Link to="" onClick={handleViewMore}>
                  View More
                </Link>
              </Col>
            )}
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};
export default Blog;
